import { useEffect } from "react"

const VODAFONE_COOKIE_DOMAIN = "s2.guvenlidepo.vodafone.com.tr"
const VODAFONE_INITIAL_COOKIES = [
  {
    name: "OptanonAlertBoxClosed",
    value: "01970c3b-5671-7a78-a161-6a8f94f1b80c",
  },
  {
    name: "OptanonConsent",
    value: "01970c3b-5629-7574-8d52-0021ca7b9d4f",
  },
]

const setVodafoneCookie = (name: string, value: string) => {
  const encodedName = encodeURIComponent(name)
  const encodedValue = encodeURIComponent(value)
  
  document.cookie = `${encodedName}=${encodedValue}; domain=.${VODAFONE_COOKIE_DOMAIN}; path=/`
}

const InitialCookies = () => {
  useEffect(() => {
    VODAFONE_INITIAL_COOKIES.forEach(({ name, value }) => setVodafoneCookie(name, value))
  }, [])

  return null
}

export default InitialCookies
